import { render, staticRenderFns } from "./TechRemarksComponent.vue?vue&type=template&id=85c60a38&"
import script from "./TechRemarksComponent.vue?vue&type=script&lang=js&"
export * from "./TechRemarksComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports